export default __webpack_public_path__ + "static/media/menu-profile-store.f9808926.svg";